<template>
  <div>
    <centers-list center-type="inactive" />
  </div>
</template>

<script>
import CentersList from "./CentersList.vue";

export default {
  components: {
    CentersList,
  },
};
</script>
